import React from 'react';
import OrderList from '../components/OrderList';
import PageHeader from '../components/common/PageHeader';
import PageContainer from '../components/common/PageContainer';

function Orders() {
  return (
    <PageContainer>
      <PageHeader title="受注管理" />
      <OrderList />
    </PageContainer>
  );
}

export default Orders;
